export const filterUndefined = (obj: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== undefined),
  );
